import axios from 'axios'
import responseInterceptor from './response.interceptor'
import requestInterceptor from './request.interceptor'
import { Storage } from '../configs/constant'
import { VIEW_TENANT_KEY } from '../contexts/ViewTenantContext'

const getUrlPrefix = () => process.env.REACT_APP_API_HREF

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

responseInterceptor(instance)
requestInterceptor(instance)

const beforeCall = (apiKey: string) => {
  instance.defaults.headers.common.api_key = apiKey
  instance.defaults.headers.common.Authorization = localStorage.getItem('token')
}
export const get = async (
  url: string,
  params = {},
  configHeaders: any = null
) => {
  try {
    configHeaders?.apiKey && beforeCall(configHeaders?.apiKey)
    const config = { params }
    const response: any = await instance.get(getUrlPrefix() + url, config)
    if (axios.isAxiosError(response)) return _errorHandler(response)
    return response
  } catch (error) {
    return _errorHandler(error)
  }
}

export const post = async (
  url: string,
  params = {},
  configHeaders: any = null
) => {
  try {
    configHeaders?.apiKey && beforeCall(configHeaders?.apiKey)
    const response = await instance.post(getUrlPrefix() + url, params)
    return response
  } catch (error) {
    return _errorHandler(error)
  }
}

export const put = async (
  url: string,
  params = {},
  configHeaders: any = null
) => {
  try {
    configHeaders?.apiKey && beforeCall(configHeaders?.apiKey)
    const response = await instance.put(getUrlPrefix() + url, params)
    return response
  } catch (error) {
    return _errorHandler(error)
  }
}

export const del = async (
  url: string,
  params = {},
  configHeaders: any = null
) => {
  try {
    configHeaders?.apiKey && beforeCall(configHeaders?.apiKey)
    const response = await instance.delete(getUrlPrefix() + url, params)
    return response
  } catch (error) {
    return _errorHandler(error)
  }
}

const _errorHandler = (err: any) => {
  if (err?.code === 'ERR_NETWORK') {
    localStorage.removeItem(Storage.TOKEN)
    localStorage.removeItem(Storage.API_KEY)
    localStorage.removeItem(VIEW_TENANT_KEY)
    window.location.href = '/'
    return
  }
  if (axios.isAxiosError(err)) {
    if (err.response?.status === 401) {
      // Clear all localStorage items
      localStorage.removeItem(Storage.TOKEN)
      localStorage.removeItem(Storage.API_KEY)
      localStorage.removeItem(VIEW_TENANT_KEY)
      
      // Redirect to login page
      window.location.href = '/login'
      return
    }
    throw err.message
  } else {
    throw err
  }
}
